import React, { useState, useEffect } from "react";
import { Card, Input, Button } from "antd";
import AlertMessage from "../components/AlertMessage";
import api from "../services/api";

const News = () => {
  const [shortId, setShortId] = useState("");
  const [alert, setAlert] = useState({ type: "", text: "" });

  // پاک کردن پیام بعد از 3 ثانیه
  useEffect(() => {
    if (alert.text) {
      const timer = setTimeout(() => {
        setAlert({ type: "", text: "" });
      }, 3000);
      return () => clearTimeout(timer); // جلوگیری از memory leak
    }
  }, [alert]);

  const handleDelete = async () => {
    if (!shortId) {
      setAlert({ type: "error", text: "لطفا shortId را وارد کنید ❌" });
      return;
    }

    try {
      const response = await api.delete(`/news/${shortId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (response.status === 200) {
        setAlert({ type: "success", text: "خبر با موفقیت حذف شد ✅" });
        setShortId("");
      } else {
        setAlert({
          type: "error",
          text: response.data.message || "خطا در حذف خبر ❌",
        });
      }
    } catch (err) {
      console.error(err);
      setAlert({ type: "error", text: "ارتباط با سرور برقرار نشد ❌" });
    }
  };

  return (
    <Card title="مدیریت اخبار">
      <AlertMessage type={alert.type} text={alert.text} />
      <Input
        placeholder="shortId خبر را وارد کنید"
        value={shortId}
        onChange={(e) => setShortId(e.target.value)}
        style={{ marginBottom: 12 }}
      />
      <Button type="primary" danger onClick={handleDelete}>
        حذف خبر
      </Button>
    </Card>
  );
};

export default News;
